<template>
  <transition
    name="modal-fade"
  >
    <div
      @click.self="!$emit('close')"
      v-hotkey="keymap"
      class="c-modal"
    >
      <button
        @click="!$emit('close')"
        type="button"
        class="c-modal__close"
        aria-label="Lukk"
        tabindex="1"
      >
        <icon-close
          class="c-icon--negative"
        />
      </button>

      <div
        class="c-modal__dialog"
        role="dialog"
      >
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
import IconClose from '@/components/icons/IconClose.vue';

export default {
  name: 'Modal',
  components: {
    IconClose,
  },
  computed: {
    keymap() {
      return {
        esc: this.close,
      };
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>